import {types} from 'mobx-state-tree';

export const ListingImage = types.map(types.string);

export type ListingImageType = typeof ListingImage.Type;

export type ListingModelViews = {
  previewImageUrl?: string;
};

const ListingModel = types
  .model('Listing', {
    id: types.identifierNumber,
    name: types.string,
    internalName: types.maybe(types.string),
    images: types.array(ListingImage)
  })
  .views<ListingModelViews>(self => ({
    get previewImageUrl() {
      const {images} = self;
      return images && images.length > 0
        ? images[0].get('small') || images[0].get('url')
        : undefined;
    }
  }));

export type ListingModelType = typeof ListingModel.Type;

export default ListingModel;



// WEBPACK FOOTER //
// ./src/models/ListingModel/ListingModel.ts